var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("article", { staticClass: "box", attrs: { id: "container" } }, [
      _c(
        "div",
        { staticClass: "orm-codemirror" },
        [
          _c("codemirror", {
            attrs: { options: _vm.options, width: _vm.editorWidth },
            model: {
              value: _vm.code,
              callback: function ($$v) {
                _vm.code = $$v
              },
              expression: "code",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }